
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import WhatsAppButton from '../../../components/feature/WhatsAppButton';
import Button from '../../../components/base/Button';
import SEOHead from '../../../components/SEO/SEOHead';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function CocopeatProductPage() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('specifications');
  const [quantity, setQuantity] = useState(1);
  const [selectedVariant, setSelectedVariant] = useState('5kg');

  const seoData = {
    title: 'کوکوپیت پریمیوم - بستر کشت ارگانیک درجه یک | گلخانه سبز آریا',
    description: 'کوکوپیت پریمیوم با کیفیت بالا، بستر کشت طبیعی و ارگانیک از الیاف نارگیل برای رشد بهینه گیاهان. نگهداری آب عالی، تهویه مناسب، pH متعادل و قابل استفاده مجدد.',
    keywords: 'کوکوپیت پریمیوم، کوکوپیت درجه یک، بستر کشت ارگانیک، الیاف نارگیل، کوکوپیت طبیعی، بستر هیدروپونیک، پیت نارگیل، کشت گلخانه‌ای، بستر کشت مناسب، کوکوپیت با کیفیت',
    ogImage: 'https://public.readdy.ai/ai/img_res/c014acacc8850ba6a9c779d37adf5221.jpg',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "کوکوپیت پریمیوم",
      "description": "بستر کشت طبیعی و ارگانیک از الیاف نارگیل با کیفیت بالا",
      "category": "بستر کشت",
      "brand": {
        "@type": "Brand",
        "name": "گلخانه سبز آریا"
      },
      "manufacturer": {
        "@type": "Organization",
        "name": "آریا گرین هاوس"
      },
      "url": "https://ariagreenhouse.com/products/1",
      "image": [
        "https://readdy.ai/api/search-image?query=premium%20coconut%20coir%20substrate%20blocks%20for%20greenhouse%20cultivation%20professional%20agricultural%20growing%20medium%20clean%20white%20background%20high%20quality%20product%20photography%20detailed%20texture&width=800&height=600&seq=cocopeat-1&orientation=landscape",
        "https://readdy.ai/api/search-image?query=coconut%20coir%20fiber%20texture%20close%20up%20detailed%20view%20natural%20organic%20growing%20medium%20professional%20agricultural%20product%20photography&width=800&height=600&seq=cocopeat-2&orientation=landscape"
      ],
      "offers": {
        "@type": "Offer",
        "url": "https://ariagreenhouse.com/products/1",
        "priceCurrency": "IRR",
        "price": "250000",
        "availability": "https://schema.org/InStock",
        "seller": {
          "@type": "Organization", 
          "name": "آریا گرین هاوس"
        }
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "156",
        "bestRating": "5",
        "worstRating": "1"
      },
      "review": [
        {
          "@type": "Review",
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5",
            "bestRating": "5"
          },
          "author": {
            "@type": "Person",
            "name": "احمد محمدی"
          },
          "reviewBody": "کیفیت فوق‌العاده‌ای داره. گیاهانم خیلی بهتر رشد کردن و نگهداری آب عالیه."
        }
      ],
      "sku": "COCO-PEAT-001",
      "mpn": "CP5KG2024",
      "gtin": "1234567890123"
    }
  };

  const variants = [
    { id: '5kg', name: '5 کیلوگرم', price: '250,000 تومان', stock: 45 },
    { id: '10kg', name: '10 کیلوگرم', price: '450,000 تومان', stock: 32 },
    { id: '25kg', name: '25 کیلوگرم', price: '980,000 تومان', stock: 18 }
  ];

  const features = [
    { icon: 'ri-leaf-line', title: '100% طبیعی و ارگانیک', description: 'از الیاف نارگیل خالص بدون هیچ‌گونه افزودنی شیمیایی' },
    { icon: 'ri-drop-line', title: 'نگهداری آب عالی', description: 'تا 8 برابر وزن خود آب نگهداری می‌کند' },
    { icon: 'ri-wind-line', title: 'تهویه مناسب', description: 'ساختار متخلخل برای تنفس بهتر ریشه‌ها' },
    { icon: 'ri-test-tube-line', title: 'pH متعادل', description: 'pH طبیعی بین 5.5 تا 6.5 مناسب اکثر گیاهان' },
    { icon: 'ri-recycle-line', title: 'قابل استفاده مجدد', description: 'تا 3 سال قابل استفاده با حفظ کیفیت' },
    { icon: 'ri-shield-check-line', title: 'عاری از آفات', description: 'تحت فرآیند حرارتی برای حذف باکتری‌ها و قارچ‌ها' }
  ];

  const specifications = {
    'حجم': '5 کیلوگرم (حدود 70 لیتر پس از آماده‌سازی)',
    'رطوبت': '15-20%',
    'pH': '5.5-6.5',
    'EC': '< 0.5 mS/cm', 
    'منشأ': 'سریلانکا',
    'بسته‌بندی': 'بلوک فشرده',
    'مدت انبارداری': '2 سال در شرایط خشک',
    'دمای نگهداری': '5-30 درجه سانتیگراد'
  };

  const usageGuide = [
    'بلوک فشرده را در ظرف بزرگ قرار دهید',
    '15-20 لیتر آب ولرم (25-30 درجه) اضافه کنید', 
    '30-45 دقیقه صبر کنید تا کاملاً باز شود',
    'با دست یا ابزار مخلوط کنید تا یکنواخت شود',
    'اضافه آب را تخلیه کرده و آماده استفاده است'
  ];

  const currentVariant = variants.find(v => v.id === selectedVariant);

  return (
    <div className="min-h-screen">
      <SEOHead {...seoData} />
      <Header />
      
      {/* Breadcrumb */}
      <section className="py-4 bg-gray-50">
        <div className="container mx-auto px-4 lg:px-8">
          <nav className="flex items-center space-x-2 text-sm">
            <Link to="/" className="text-gray-500 hover:text-green-600 cursor-pointer">صفحه اصلی</Link>
            <i className="ri-arrow-left-s-line text-gray-400"></i>
            <Link to="/products" className="text-gray-500 hover:text-green-600 cursor-pointer">محصولات</Link>
            <i className="ri-arrow-left-s-line text-gray-400"></i>
            <span className="text-gray-700">کوکوپیت پریمیوم</span>
          </nav>
        </div>
      </section>

      {/* Product Detail */}
      <section className="py-12">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Product Images */}
            <div className="space-y-4">
              <div className="relative">
                <img 
                  src="https://readdy.ai/api/search-image?query=premium%20coconut%20coir%20substrate%20blocks%20for%20greenhouse%20cultivation%20professional%20agricultural%20growing%20medium%20clean%20white%20background%20high%20quality%20product%20photography%20detailed%20texture%20expanded%20cocopeat&width=600&height=500&seq=cocopeat-main&orientation=landscape"
                  alt="کوکوپیت پریمیوم"
                  className="w-full h-96 object-cover object-center rounded-2xl"
                />
                <div className="absolute top-4 right-4 bg-green-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                  پرفروش
                </div>
                <div className="absolute top-4 left-4 bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                  ارگانیک
                </div>
              </div>
              
              <div className="grid grid-cols-4 gap-4">
                <img 
                  src="https://readdy.ai/api/search-image?query=coconut%20coir%20fiber%20texture%20close%20up%20detailed%20view%20natural%20organic%20growing%20medium%20professional%20agricultural%20product%20photography&width=200&height=150&seq=cocopeat-detail-1&orientation=landscape"
                  alt="جزئیات کوکوپیت"
                  className="w-full h-20 object-cover rounded-lg cursor-pointer hover:opacity-75 transition-opacity"
                />
                <img 
                  src="https://readdy.ai/api/search-image?query=coconut%20coir%20substrate%20in%20greenhouse%20cultivation%20healthy%20plant%20roots%20growing%20medium%20professional%20agriculture&width=200&height=150&seq=cocopeat-detail-2&orientation=landscape"
                  alt="کاربرد کوکوپیت"
                  className="w-full h-20 object-cover rounded-lg cursor-pointer hover:opacity-75 transition-opacity"
                />
                <img 
                  src="https://readdy.ai/api/search-image?query=compressed%20coconut%20coir%20blocks%20before%20expansion%20professional%20agricultural%20product%20clean%20background&width=200&height=150&seq=cocopeat-detail-3&orientation=landscape"
                  alt="بلوک فشرده"
                  className="w-full h-20 object-cover rounded-lg cursor-pointer hover:opacity-75 transition-opacity"
                />
                <img 
                  src="https://readdy.ai/api/search-image?query=coconut%20coir%20mixed%20with%20water%20expansion%20process%20agricultural%20growing%20medium%20preparation&width=200&height=150&seq=cocopeat-detail-4&orientation=landscape"
                  alt="فرآیند آماده‌سازی"
                  className="w-full h-20 object-cover rounded-lg cursor-pointer hover:opacity-75 transition-opacity"
                />
              </div>
            </div>

            {/* Product Info */}
            <div className="space-y-6">
              <div>
                <h1 className="text-4xl font-bold text-gray-800 mb-4">کوکوپیت پریمیوم</h1>
                <p className="text-xl text-gray-600 leading-relaxed">
                  بستر کشت طبیعی و ارگانیک از الیاف نارگیل با کیفیت بالا، مناسب برای کشت هیدروپونیک، گلخانه‌ای و باغبانی خانگی
                </p>
              </div>

              {/* Rating */}
              <div className="flex items-center space-x-4">
                <div className="flex items-center text-yellow-500">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <span className="text-gray-600 mr-2">4.8</span>
                </div>
                <span className="text-gray-500">(156 نظر)</span>
                <span className="text-green-600 font-medium">موجود در انبار</span>
              </div>

              {/* Variant Selection */}
              <div className="space-y-4">
                <h3 className="text-lg font-bold text-gray-800">انتخاب حجم:</h3>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                  {variants.map((variant) => (
                    <button
                      key={variant.id}
                      onClick={() => setSelectedVariant(variant.id)}
                      className={`p-4 border-2 rounded-xl text-center transition-all cursor-pointer ${
                        selectedVariant === variant.id
                          ? 'border-green-600 bg-green-50 text-green-700'
                          : 'border-gray-200 hover:border-green-300'
                      }`}
                    >
                      <div className="font-bold">{variant.name}</div>
                      <div className="text-sm text-gray-600">{variant.price}</div>
                      <div className="text-xs text-gray-500">{variant.stock} موجود</div>
                    </button>
                  ))}
                </div>
              </div>

              {/* Price */}
              <div className="bg-gray-50 p-6 rounded-2xl">
                <div className="flex items-center justify-between mb-4">
                  <span className="text-3xl font-bold text-green-600">{currentVariant?.price}</span>
                  <span className="text-gray-500 line-through">300,000 تومان</span>
                </div>
                <div className="text-sm text-gray-600 mb-4">
                  ✅ ارسال رایگان برای سفارش‌های بالای 500,000 تومان
                </div>
              </div>

              {/* Quantity & Add to Cart */}
              <div className="space-y-4">
                <div className="flex items-center space-x-4">
                  <span className="text-lg font-medium">تعداد:</span>
                  <div className="flex items-center border border-gray-300 rounded-lg">
                    <button 
                      onClick={() => setQuantity(Math.max(1, quantity - 1))}
                      className="px-3 py-2 hover:bg-gray-50 cursor-pointer"
                    >
                      <i className="ri-subtract-line"></i>
                    </button>
                    <span className="px-4 py-2 border-x border-gray-300">{quantity}</span>
                    <button 
                      onClick={() => setQuantity(Math.min(currentVariant?.stock || 1, quantity + 1))}
                      className="px-3 py-2 hover:bg-gray-50 cursor-pointer"
                    >
                      <i className="ri-add-line"></i>
                    </button>
                  </div>
                  <span className="text-sm text-gray-500">حداکثر {currentVariant?.stock} عدد</span>
                </div>

                <div className="flex gap-4">
                  <button className="flex-1 bg-green-600 hover:bg-green-700 text-white py-4 px-6 rounded-xl font-bold text-lg transition-colors cursor-pointer whitespace-nowrap">
                    <i className="ri-shopping-cart-line ml-2"></i>
                    افزودن به سبد خرید
                  </button>
                  <button className="px-4 py-4 border border-gray-300 rounded-xl hover:bg-gray-50 cursor-pointer">
                    <i className="ri-heart-line text-xl"></i>
                  </button>
                  <button className="px-4 py-4 border border-gray-300 rounded-xl hover:bg-gray-50 cursor-pointer">
                    <i className="ri-share-line text-xl"></i>
                  </button>
                </div>
              </div>

              {/* Quick Actions */}
              <div className="grid grid-cols-2 gap-4">
                <button className="bg-blue-600 hover:bg-blue-700 text-white py-3 px-4 rounded-xl font-medium transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-phone-line ml-2"></i>
                  تماس برای مشاوره
                </button>
                <button className="bg-orange-600 hover:bg-orange-700 text-white py-3 px-4 rounded-xl font-medium transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-calculator-line ml-2"></i>
                  محاسبه هزینه حمل
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Details Tabs */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4 lg:px-8">
          {/* Tab Navigation */}
          <div className="flex flex-wrap border-b border-gray-200 mb-8">
            {[
              { id: 'specifications', name: 'مشخصات فنی', icon: 'ri-settings-line' },
              { id: 'features', name: 'ویژگی‌ها', icon: 'ri-star-line' },
              { id: 'usage', name: 'نحوه استفاده', icon: 'ri-book-open-line' },
              { id: 'reviews', name: 'نظرات (156)', icon: 'ri-chat-1-line' }
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center space-x-2 px-6 py-4 font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  activeTab === tab.id
                    ? 'text-green-600 border-b-2 border-green-600'
                    : 'text-gray-600 hover:text-green-600'
                }`}
              >
                <i className={tab.icon}></i>
                <span>{tab.name}</span>
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div className="bg-white rounded-2xl p-8">
            {activeTab === 'specifications' && (
              <div className="space-y-6">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">مشخصات فنی</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {Object.entries(specifications).map(([key, value]) => (
                    <div key={key} className="flex justify-between py-3 border-b border-gray-100">
                      <span className="font-medium text-gray-700">{key}:</span>
                      <span className="text-gray-600">{value}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {activeTab === 'features' && (
              <div className="space-y-6">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">ویژگی‌ها و مزایا</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {features.map((feature, index) => (
                    <div key={index} className="flex items-start space-x-4 p-4 bg-gray-50 rounded-xl">
                      <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className={`${feature.icon} text-green-600 text-xl`}></i>
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-800 mb-2">{feature.title}</h4>
                        <p className="text-gray-600 text-sm leading-relaxed">{feature.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {activeTab === 'usage' && (
              <div className="space-y-6">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">نحوه آماده‌سازی و استفاده</h3>
                <div className="space-y-4">
                  {usageGuide.map((step, index) => (
                    <div key={index} className="flex items-start space-x-4 p-4 bg-blue-50 rounded-xl">
                      <div className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold text-sm flex-shrink-0">
                        {index + 1}
                      </div>
                      <p className="text-gray-700 leading-relaxed">{step}</p>
                    </div>
                  ))}
                </div>
                
                <div className="mt-8 bg-green-50 p-6 rounded-xl">
                  <h4 className="font-bold text-green-800 mb-4">
                    <i className="ri-lightbulb-line ml-2"></i>
                    توصیه‌های مهم:
                  </h4>
                  <ul className="space-y-2 text-green-700">
                    <li>• برای بهترین نتیجه از آب با دمای 25-30 درجه استفاده کنید</li>
                    <li>• می‌توانید با پیت ماس یا پرلیت مخلوط کنید</li>
                    <li>• قبل از کاشت pH را بررسی کنید</li>
                    <li>• برای استفاده مجدد، کاملاً خشک کرده و نگهداری کنید</li>
                  </ul>
                </div>
              </div>
            )}

            {activeTab === 'reviews' && (
              <div className="space-y-6">
                <div className="flex items-center justify-between">
                  <h3 className="text-2xl font-bold text-gray-800">نظرات مشتریان</h3>
                  <button className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-medium cursor-pointer whitespace-nowrap">
                    ثبت نظر جدید
                  </button>
                </div>
                
                {/* Reviews Summary */}
                <div className="bg-gray-50 p-6 rounded-xl">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="text-center">
                      <div className="text-4xl font-bold text-green-600 mb-2">4.8</div>
                      <div className="flex justify-center text-yellow-500 mb-2">
                        <i className="ri-star-fill"></i>
                        <i className="ri-star-fill"></i>
                        <i className="ri-star-fill"></i>
                        <i className="ri-star-fill"></i>
                        <i className="ri-star-fill"></i>
                      </div>
                      <div className="text-gray-600">بر اساس 156 نظر</div>
                    </div>
                    <div className="space-y-2">
                      {[5, 4, 3, 2, 1].map((stars) => (
                        <div key={stars} className="flex items-center space-x-2">
                          <span className="text-sm w-8">{stars}</span>
                          <i className="ri-star-fill text-yellow-500 text-sm"></i>
                          <div className="flex-1 bg-gray-200 rounded-full h-2">
                            <div 
                              className="bg-green-600 h-2 rounded-full"
                              style={{ width: `${stars === 5 ? 75 : stars === 4 ? 20 : 3}%` }}
                            ></div>
                          </div>
                          <span className="text-sm text-gray-600 w-8">
                            {stars === 5 ? '117' : stars === 4 ? '31' : stars === 3 ? '5' : stars === 2 ? '2' : '1'}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Sample Reviews */}
                <div className="space-y-6">
                  <div className="border border-gray-200 rounded-xl p-6">
                    <div className="flex items-start justify-between mb-4">
                      <div>
                        <div className="font-bold text-gray-800">احمد محمدی</div>
                        <div className="text-sm text-gray-500">2 هفته پیش</div>
                      </div>
                      <div className="flex text-yellow-500">
                        <i className="ri-star-fill"></i>
                        <i className="ri-star-fill"></i>
                        <i className="ri-star-fill"></i>
                        <i className="ri-star-fill"></i>
                        <i className="ri-star-fill"></i>
                      </div>
                    </div>
                    <p className="text-gray-700 leading-relaxed">
                      کیفیت فوق‌العاده‌ای داره. گیاهانم خیلی بهتر رشد کردن و نگهداری آب عالیه. 
                      قطعاً دوباره سفارش می‌دم. بسته‌بندی هم خیلی خوب بود.
                    </p>
                  </div>

                  <div className="border border-gray-200 rounded-xl p-6">
                    <div className="flex items-start justify-between mb-4">
                      <div>
                        <div className="font-bold text-gray-800">فاطمه احمدی</div>
                        <div className="text-sm text-gray-500">1 ماه پیش</div>
                      </div>
                      <div className="flex text-yellow-500">
                        <i className="ri-star-fill"></i>
                        <i className="ri-star-fill"></i>
                        <i className="ri-star-fill"></i>
                        <i className="ri-star-fill"></i>
                        <i className="ri-star-line"></i>
                      </div>
                    </div>
                    <p className="text-gray-700 leading-relaxed">
                      برای گلخانه خانگیم استفاده کردم. نتیجه خیلی خوب بود. 
                      فقط کاش راهنمای کاملتری داشت.
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Related Products */}
      <section className="py-20">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">محصولات مرتبط</h2>
            <p className="text-gray-600">محصولات دیگری که ممکن است به آن‌ها نیاز داشته باشید</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              {
                id: 2,
                name: 'پیت ماس کانادایی',
                price: '320,000 تومان',
                image: 'https://readdy.ai/api/search-image?query=Canadian%20peat%20moss%20premium%20quality%20growing%20medium%20for%20greenhouse%20professional%20horticultural%20substrate%20clean%20packaging&width=300&height=200&seq=peat-related&orientation=landscape'
              },
              {
                id: 3,
                name: 'نخ UV گلخانه',
                price: '85,000 تومان',
                image: 'https://readdy.ai/api/search-image?query=UV%20resistant%20greenhouse%20twine%20rope%20for%20plant%20support%20professional%20agricultural%20equipment&width=300&height=200&seq=twine-related&orientation=landscape'
              },
              {
                id: 4,
                name: 'توری ضد تریپس',
                price: '120,000 تومان',
                image: 'https://readdy.ai/api/search-image?query=anti-thrips%20insect%20screen%20mesh%20for%20greenhouse%20protection%20fine%20mesh%20agricultural%20netting&width=300&height=200&seq=net-related&orientation=landscape'
              },
              {
                id: 5,
                name: 'چسب ترمیم پلاستیک',
                price: '45,000 تومان',
                image: 'https://readdy.ai/api/search-image?query=greenhouse%20plastic%20repair%20tape%20transparent%20adhesive%20tape%20for%20agricultural%20use%20professional%20quality&width=300&height=200&seq=tape-related&orientation=landscape'
              }
            ].map((product) => (
              <div key={product.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300">
                <img 
                  src={product.image}
                  alt={product.name}
                  className="w-full h-40 object-cover object-top"
                />
                <div className="p-4">
                  <h3 className="font-bold text-gray-800 mb-2">{product.name}</h3>
                  <div className="flex items-center justify-between">
                    <span className="text-green-600 font-bold">{product.price}</span>
                    <Link 
                      to={`/products/${product.id}`}
                      className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded-lg text-sm cursor-pointer whitespace-nowrap"
                    >
                      مشاهده
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
